import React from 'react';
import { Link } from 'react-router-dom';
import { useReferrer } from '../hooks/useReferrer';

/**
 * Fixed-height row above a list page's title. It always takes up space so the
 * title does not shift. When a caller (not the menu) linked here with
 * `referrerState(location, label)`, it shows "← label" back to the caller's
 * full URL.
 */
export const ReferrerBackLink: React.FC = () => {
  const referrer = useReferrer();
  return (
    <div className="tw:h-6 tw:flex tw:items-center" data-testid="referrer-back-link-row">
      {referrer && (
        <Link
          to={referrer.url}
          className="tw:inline-flex tw:items-center tw:gap-1 tw:text-sm tw:!text-brand-green-0 tw:!no-underline tw:hover:!text-brand-green-1"
          data-testid="referrer-back-link"
        >
          <i className="far fa-arrow-left" />
          {referrer.label || 'Back'}
        </Link>
      )}
    </div>
  );
};
